import instance from './instance';

export const createUpdate = data => instance.post('/update_ais', data);

export const fetchJiraProjectEpics = () => instance.get('/update_ais/jira_project_epics');

export const fetchAsanaWorkspaceProjects = () => instance.get('/update_ais/asana_workspace_projects');
